import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-new-tyre-badge',
  templateUrl: './new-tyre-badge.component.html',
  styleUrls: ['./new-tyre-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewTyreBadgeComponent {}
